import {ComparisonRow} from './buildComparisonRows';
import {translateWithFallback as t} from './translateWithFallback';

/** English fallbacks of the fixed row labels; keys come from `buildComparisonRows`. */
const ROW_LABEL_FALLBACKS: Record<string, string> = {
  vehiclePrice: 'Vehicle & factory equipment',
  discount: 'Customer discount',
  accessories: 'Dealer accessories',
  totalWithoutVat: 'Total without VAT',
  vat: 'VAT',
  source: 'Condition / source',
  availability: 'Availability',
  delivery: 'Delivery',
  customerNote: 'Note from your adviser',
  vin: 'VIN',
  validUntil: 'Offer valid until',
  firstRegistration: 'First registration',
  mileage: 'Mileage',
  engine: 'Engine',
  power: 'Power',
  fuel: 'Fuel',
  transmissionDrive: 'Transmission / drive',
  exteriorColor: 'Exterior colour',
  interiorColor: 'Interior',
};

export const getComparisonRowLabel = (row: ComparisonRow) =>
  row.label ?? t(row.labelKey ?? '', ROW_LABEL_FALLBACKS[row.id] ?? row.id);
